shvenergy.mobilefixedheader = (function ($) {
	"use strict";

	var $html = $('html');
	var $stickyHeader = $('.mobile-header__sticky');
	var $pageContent = $('#main');
	var $offset = 50;
	var $window = $(window);

	var enabled = true;

	$html.removeClass("no-js").addClass("js");

	function checkScrollPosition() {

		if (window.matchMedia("screen and (min-width: 640px)").matches) {
			return;
		}

		var scrollTop = $window.scrollTop();
		scrollTop >= $offset ? $stickyHeader.addClass('is-stuck') : $stickyHeader.removeClass('is-stuck');
	}

	function disableScrollPosition(){
		enabled = false;
	}
	function enableScrollPosition(){
		enabled = true;
	}

	function init() {

		$window.on("scroll", function () {
			if(enabled){
				checkScrollPosition();
			}
		});

		$window.on("resize", function () {

			$pageContent.removeAttr("style");

			if (window.matchMedia("screen and (min-width: 640px)").matches) {
				$stickyHeader.removeClass('is-stuck');
			} else {
				//checkScrollPosition();
				if(enabled){
					checkScrollPosition();
				}
			}

		});
		
	}

	init();

	return {
		disableScrollPosition: disableScrollPosition,
		enableScrollPosition: enableScrollPosition
	};

})(jQuery);